// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3qPTw","select":"Header_select__1Lz6l","clinic":"Header_clinic__3r5zj"};